import { render, staticRenderFns } from "./TabsPanel.vue?vue&type=template&id=5469cc0c&scoped=true"
import script from "./TabsPanel.vue?vue&type=script&lang=js"
export * from "./TabsPanel.vue?vue&type=script&lang=js"
import style0 from "./TabsPanel.vue?vue&type=style&index=0&id=5469cc0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5469cc0c",
  null
  
)

export default component.exports